import * as THREE from '../extras/three'
import { System } from './System'

// highlight overlays for the user's owned plots and the selected plot
// (the full 4096-plot wall set is rendered by the Boundary system via setPlotGrid)
export class ClientPlots extends System {
  constructor(world) {
    super(world)
    this.plots = []
    this.active = null
    this.ownedMesh = null
    this.activeMesh = null
    this.onPlots = list => this.setPlots(list)
    this.onActive = plot => this.setActive(plot || null)
    this.world.on('plots', this.onPlots)
    this.world.on('activePlot', this.onActive)
  }

  start() {
    if (this.world.plots?.length && !this.ownedMesh) this.setPlots(this.world.plots)
  }

  setPlots(plots) {
    this.plots = plots || []
    this.rebuildOwned()
  }

  setActive(plot) {
    this.active = plot
    this.rebuildActive()
  }

  rebuildOwned() {
    const scene = this.world.stage?.scene
    if (!scene) return
    if (this.ownedMesh) {
      scene.remove(this.ownedMesh)
      this.ownedMesh.geometry.dispose()
      this.ownedMesh.material.dispose()
      this.ownedMesh = null
    }
    if (!this.plots.length) return
    const mesh = buildOutlines(this.plots, 0x4fc3f7, 12)
    mesh.name = 'plot-owned'
    this.ownedMesh = mesh
    scene.add(mesh)
  }

  rebuildActive() {
    const scene = this.world.stage?.scene
    if (!scene) return
    if (this.activeMesh) {
      scene.remove(this.activeMesh)
      this.activeMesh.geometry.dispose()
      this.activeMesh.material.dispose()
      this.activeMesh = null
    }
    if (!this.active) return
    const mesh = buildOutlines([this.active], 0x00ff66, 14)
    mesh.name = 'plot-active'
    this.activeMesh = mesh
    scene.add(mesh)
  }

  destroy() {
    this.world.off('plots', this.onPlots)
    this.world.off('activePlot', this.onActive)
    this.setPlots([])
    this.setActive(null)
  }
}

function buildOutlines(plots, color, height) {
  const edges = 12
  const positions = new Float32Array(plots.length * edges * 2 * 3)
  let p = 0
  for (const plot of plots) {
    const half = plot.size / 2
    const cx = plot.centerX
    const cz = plot.centerZ
    const y0 = 0.1
    const y1 = height
    const c = [
      [cx - half, y0, cz - half],
      [cx + half, y0, cz - half],
      [cx + half, y0, cz + half],
      [cx - half, y0, cz + half],
      [cx - half, y1, cz - half],
      [cx + half, y1, cz - half],
      [cx + half, y1, cz + half],
      [cx - half, y1, cz + half],
    ]
    const idx = [
      0, 1, 1, 2, 2, 3, 3, 0,
      4, 5, 5, 6, 6, 7, 7, 4,
      0, 4, 1, 5, 2, 6, 3, 7,
    ]
    for (let i = 0; i < idx.length; i++) {
      const v = c[idx[i]]
      positions[p++] = v[0]
      positions[p++] = v[1]
      positions[p++] = v[2]
    }
  }
  const geom = new THREE.BufferGeometry()
  geom.setAttribute('position', new THREE.BufferAttribute(positions, 3))
  const mat = new THREE.LineBasicMaterial({ color, transparent: true, opacity: 0.95, depthTest: true })
  return new THREE.LineSegments(geom, mat)
}
